import React from 'react';
import PropTypes from 'prop-types';
import { Dthc } from '../../../Modules';
import NotesEditDesktop from './NotesEditDesktop';
import NotesEditMobile from './NotesEditMobile';
import styles from './Notes.scss';

export default class NotesComponent extends React.Component {
  static propTypes = {
    canEdit: PropTypes.bool.isRequired,
    localNotes: PropTypes.string,
    reset: PropTypes.func.isRequired,
    notes: PropTypes.string,
    notesChangeHandler: PropTypes.func.isRequired,
    updateNotes: PropTypes.func.isRequired
  };

  render() {
    const {
      canEdit,
      localNotes,
      reset,
      notes,
      notesChangeHandler,
      updateNotes
    } = this.props;
    const NotesShow = (
      <div>
        {!notes &&
          <p style={{ padding: '1em' }} onClick={this.addNew}><em>Click to add notes...</em></p>}
        {notes &&
          <div
            style={{ padding: '1em', wordBreak: 'break-word' }}
            dangerouslySetInnerHTML={{ __html: notes }}
          />}
      </div>
    );
    return (
      <div className={styles.notes}>
        {canEdit &&
          <Dthc
            desktop={NotesEditDesktop}
            mobile={NotesEditMobile}
            onChange={notesChangeHandler}
            commitUpdate={updateNotes}
            reset={reset}
            value={localNotes}
          >
            {NotesShow}
          </Dthc>}
        {!canEdit && NotesShow}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Notes/Notes.js